import React, { Component } from "react";
import { FormattedMessage, injectIntl } from 'react-intl'
import upgradeVip from "./res/phonedownload/upgrade_vip.png"

import { QRCodeSVG } from 'qrcode.react'

import { message } from 'antd';
import Locale from './lang/Locale'

import "./TimeTable2.css";
import "antd/dist/antd.min.css";
import "url-search-params-polyfill"

class TimeTable2 extends Component {

    constructor(props) {

        super(props);

        
        const { intl } = this.props;

        this.state = {
            vipdisplay:'none',
            userAvatar  : '',
            ioslink:'',
            otherlink:'',
            qrCodeValue:'',
            nickName:'',
            timeTableTitle:''
        };
    }

    componentWillMount() {
        const { intl } = this.props;

        let lang = Locale.Instance.getLang();
        
        var search = new URLSearchParams(window.location.search);
        let code = search.get("code");


        let country = 'us';
        if( lang === 'chs' ) {
            country = 'cn';
        } else if( lang === 'cht' ) {
            country = 'tw';
        } else if( lang === 'kor' ) {
            country = 'kr';
        }

        if (code != null && code != '') {
            var text = '{"type":"timetable_share","value":"' + code + '"}';
            this.setState( { qrCodeValue : text });
            this.getTimeTableInfo(code);
        }

    }

    async getTimeTableInfo(code) {
        
        let retobj = await fetch( 'https://data.xdiarys.com/api/event/v1/getShareInfoByCode?code=' + code, {
            method: "GET",
            credentials: 'include',
            headers: {
            'Accept': 'application/json, text/plain, */*',
            }
        })
        .then(function (response) {
            return  response.json();
        })
        .then((myJson) => {
            return myJson;
        })
        .catch(function (e) {
            console.log( e );
        });

        
        console.log( retobj );
        if( retobj.result === 1 ) {
            this.setState( { nickName : retobj.vdata.user_nickname });
            this.setState( { userAvatar : retobj.vdata.avatar });
            this.setState( { timeTableTitle : retobj.vdata.timetable_title });
        } else{
            message.error("获取分享信息失败！");
        }
    }

    render() {

        let logo = require("./res/homepage/homepage_logo.png")
        let okIco = require("./res/timetable2/ok.png")
        let image_tbico = require("./res/timetable2/image@2x.png")
        let image_step1 = require("./res/timetable2/step1-chs.png")

        let image_1 = require("./res/timetable/phone-chs.png")
        let step2Class = "tb2-body-step2"
        
        let locale = Locale.Instance.getLocal();
        let lang = Locale.Instance.getLang();
        if (locale === 'ko' || lang === 'kor') {
            image_1 = require("./res/phonedownload/kor_1.jpg")
            image_step1 = require("./res/timetable2/step1-kor.png")
            step2Class = "tb2-body-step2 step2-kor"
        }
        else if(locale === 'zh-tw' || lang === 'cht' ) {
            image_1 = require("./res/phonedownload/cht_1.jpg")
            image_step1 = require("./res/timetable2/step1-cht.png")
            step2Class = "tb2-body-step2 step2-cht"
        }
        else if(locale === 'en' || lang === 'usa' ) {
            image_1 = require("./res/phonedownload/usa_1.jpg")
            image_step1 = require("./res/timetable2/step1-usa.png")
            step2Class = "tb2-body-step2 step2-usa"
        }


        return (
        <div className="tb2-all" >
            <div className="tb2-header">
                <div className="tb2-header-content">
                    <div className="tb2-header-left" >
                        <div className="tb2-logo">
                            <img src={logo} className="img-logo" />
                            <FormattedMessage id='tt_title' />
                        </div>
                        <div className="tb2-share-desc">
                            <span className="color-name">{this.state.nickName}</span><FormattedMessage id='tt_share_1' />
                            <br/>
                            <span className="color-tbname">{this.state.timeTableTitle}</span><FormattedMessage id='tt_share_2' />
                        </div>
                        
                    </div>
                    <div className="tb2-header-right" >
                        <img src={image_tbico} className="imageTbIco" />
                    </div>
                </div>
            </div>
            <div className="tb2-body">
                <div className="tb2-body-step1">
                    <img src={image_step1} />
                </div>
                <div className={step2Class}>
                    
                    <div className="step2-desc">
                    <FormattedMessage id='tt_share_show_1' />“{this.state.nickName}”<FormattedMessage id='tt_share_show_2' />
                    </div>
                    <div className="step2-avatar">
                        <div className="img-area">
                            <img src={this.state.userAvatar} />
                            <br/>
                            <span className="img-area-name">{this.state.nickName}<FormattedMessage id='tt_share_show_2' /></span>
                        </div>
                    </div>
                    <div className="step2-qrcode">
                        <div className="qrcode-area">
                        <QRCodeSVG id="qrcode" width={86} height={86} marginSize="0" value={this.state.qrCodeValue} />
                        </div>
                    </div>
                    <div className="step2-tips">
                        <div className="tips-left">
                            <div className="tips-scan">
                                <FormattedMessage id='tt_share_scan_1' /><img src={logo} className="tips-ico" />
                                <FormattedMessage id='tt_share_scan_2' />
                            </div>
                        </div>
                        <div className="tips-right">
                            <div className="tips-sync">
                                <img src={okIco} className="tips-ico" />
                                <FormattedMessage id='tt_share_succ' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tb2-body-copy">

                    <div className="copyrighttext">
                        Copyright © Beijing Xiaowei Cloud Service Technology Co., Ltd.&nbsp;&nbsp;&nbsp;&nbsp;<FormattedMessage id='phodedownload_copyright' />
                    </div>
                </div>

                
            </div>

        </div>
        )
    }
}



export default injectIntl(TimeTable2);